import axios from "./axiosConfig";

const saveToMongoFunction = async (
  examId,
  examDetail,
  setWindowSwitch,
  setTestData,
  _windowSwitchCount,
  faceNotFoundCount,
  testData,
  statusOnFinish,
  setisMongoUpdated
) => {
  // Don't save if test is already submitted (status 010, 011, or 111)
  const currentStatus = examDetail[0].status;
  if (currentStatus === "010" || currentStatus === "011" || currentStatus === "111" || currentStatus === "113" || currentStatus === "114") {
    console.log("Test already submitted, skipping auto-save");
    return true;
  }

  let remainingTime = window.localStorage.getItem("remainingTime");

  if (statusOnFinish) {
    examDetail[0].status = statusOnFinish;
  } else {
    examDetail[0].status = "001";
  }

  // Ensure time_remaining is always valid. Never fabricate a small number here - a `1`
  // is a technically-valid number, so none of the backend's null/NaN fallback logic
  // catches it: it gets saved as-is, and this candidate's next resume/refresh reads it
  // back as "already expired," producing a real false timeout for someone still
  // actively taking the test. Full allotted duration instead, same as everywhere else.
  const isValidRemainingTime = remainingTime !== null && remainingTime !== undefined && remainingTime !== "" && !isNaN(Number(remainingTime));
  if (isValidRemainingTime) {
    examDetail[0].time_remaining = Number(remainingTime);
  } else {
    const totalTestTime = examDetail[0].total_test_time || (examDetail[0].instanceduration * 60);
    examDetail[0].time_remaining = totalTestTime;
    console.log("Investigate: time_remaining null in saveToMongoFunction.js - AUTO-SAVE, localStorage had no time, falling back to full allotted duration:", totalTestTime);
  }
  // Window switches not yet taken off the allowance are kept on examDetail[0].pendingWindowSwitches
  // (WindowFocusHandler.jsx), not in the windowSwitchCount argument: the photo checks call this from
  // timers holding an old copy of that count, which took a switch off twice (2 switches used up 3)
  // or reset unsaved switches to 0 (switches never recorded) - staging 809503 / 809583, 21 Oct 2026.
  const pendingSwitches = Number(examDetail[0].pendingWindowSwitches) || 0;
  examDetail[0].webproctoringcount = Math.max(0, examDetail[0].webproctoringcount - pendingSwitches);
  examDetail[0].pendingWindowSwitches = 0;
  if (pendingSwitches > 0) setWindowSwitch(0);
  // Unlike windowSwitchCount (reset to 0 after every save, so webproctoringcount is a
  // draining per-cycle budget), faceNotFoundCount is never reset - every reader
  // (Test.jsx:308, NoFaceModal.jsx, ImageProctoring.jsx:1029) already compares it as the
  // full cumulative violation count against examDetail[0].imageproctoringcount, which is meant
  // to stay at its original admin-configured limit for that comparison to mean anything.
  // Draining it here too compounds on every save and aborts the exam far earlier than
  // configured (limit=10 aborting after ~5 violations) - so facenotfoundcount must not be
  // mutated at all, unlike webproctoringcount below.
  if (examDetail[0].defaultZeroProctorCheck !== true) {
    if (examDetail[0].webproctoringcount === 0) {
      examDetail[0].webproctoringzero = true;
    }
  }

  let stringifyExamDetail = JSON.stringify(examDetail);
  let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)));

  let stringifyQuesData = JSON.stringify(testData);
  let encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)));
  // Retry with backoff: a single transient failure previously lost the Mongo write
  // permanently because the outer onSubmit would fall back to /independent-resultprocess
  // which does not write Mongo. We only retry on network/5xx; 4xx is non-retriable.
  const MAX_ATTEMPTS = 3;
  const BACKOFFS_MS = [500, 1000, 2000];
  let lastError = null;

  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      await axios.post("/test/answeredQuestions", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        examDetail: encodedExamDetail,
        id: examDetail[0].id,
        quesData: encodedQuesData,
      });

      examDetail[0].lastSyncTimestamp = new Date().toISOString();
      console.log(`✅ Data saved to MongoDB at: ${examDetail[0].lastSyncTimestamp}${attempt > 1 ? ` (attempt ${attempt})` : ""}`);

      if (setisMongoUpdated !== undefined) {
        setisMongoUpdated(true);
      }
      window.localStorage.removeItem(examId);
      window.localStorage.removeItem("remainingTime");
      return true;
    } catch (error) {
      lastError = error;
      const httpStatus = error?.response?.status;
      const isNonRetriable = httpStatus >= 400 && httpStatus < 500;
      console.log(`saveToMongoFunction attempt ${attempt}/${MAX_ATTEMPTS} failed (status=${httpStatus || "network"}):`, error?.message || error);

      if (isNonRetriable || attempt === MAX_ATTEMPTS) break;
      await new Promise((resolve) => setTimeout(resolve, BACKOFFS_MS[attempt - 1]));
    }
  }

  console.log("saveToMongoFunction gave up after retries:", lastError?.message || lastError);
  return false;
};
export default saveToMongoFunction;
